module.exports = __webpack_public_path__ + "images/generic-business-logo-small@1x-05db8e479be84ac512f49bd64d46f58e.png";